var map = {
	"./abb-color.svg": 1723,
	"./afb-color.svg": 1724,
	"./afb.svg": 1725,
	"./alb-color.svg": 1726,
	"./alb.svg": 1727,
	"./amb-color.svg": 1728,
	"./amb.svg": 1729,
	"./bbbaidja-color.svg": 1730,
	"./bbbaidjaxxx-color.svg": 1731,
	"./bdinidjaxxx-color.svg": 1732,
	"./bimb-color.svg": 1733,
	"./bimb.svg": 1734,
	"./bkr-color.svg": 1735,
	"./bkr.svg": 1736,
	"./bmriidja-color.svg": 1737,
	"./bniaidja-color.svg": 1738,
	"./bninidja-color.svg": 1739,
	"./bninidjaxxx-color.svg": 1740,
	"./bpay-color.svg": 1741,
	"./brinidja002-color.svg": 1742,
	"./bsmdidjaxxx-color.svg": 1743,
	"./bsn-color.svg": 1744,
	"./bsn.svg": 1745,
	"./btanidjaxxx-color.svg": 1746,
	"./cenaidja-color.svg": 1747,
	"./cenaidjaxxx-color.svg": 1748,
	"./cimb-color.svg": 1749,
	"./cimb.svg": 1750,
	"./citi-color.svg": 1751,
	"./citi.svg": 1752,
	"./default-bank-icon-color.png": 1753,
	"./default-bank-icon.png": 1754,
	"./gxbank-color.svg": 1755,
	"./hlb-color.svg": 1756,
	"./hlb.svg": 1757,
	"./hsbc-color.svg": 1758,
	"./hsbc.svg": 1759,
	"./ibbkidjaxxx-color.svg": 1760,
	"./kwh-color.svg": 1761,
	"./kwh.svg": 1762,
	"./mbb-color.svg": 1763,
	"./mbb.svg": 1764,
	"./nispidjaxxx-color.svg": 1765,
	"./ocbc-color.svg": 1766,
	"./ocbc.svg": 1767,
	"./pbb-color.svg": 1768,
	"./pbb.svg": 1769,
	"./pinbidja-color.svg": 1770,
	"./rhb-b.svg": 1771,
	"./rhb-color-b.svg": 1772,
	"./rhb-color.svg": 1773,
	"./rhb.svg": 1774,
	"./scb-color.svg": 1775,
	"./scb.svg": 1776,
	"./tng-color.svg": 1777,
	"./uob-color.svg": 1778,
	"./uob.svg": 1779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;